import React from 'react'

function Breadcrumbs({ title, active, progress, }) {
  return (
    <div className="col-8 align-self-center">
      <div className="progress">
        <div className="progress-bar" role="progressbar" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100" style={{ width: progress }}></div>
        <ul className={`d-flex w-100 p-0 m-0 active${active}`}>
          <li><span>1</span></li>
          <li><span>2</span></li>
          <li><span>3</span></li>
        </ul>
      </div>
      <div className="text-center progress-label mt-2">{title}</div>
    </div>
  )
}

export default Breadcrumbs